<mat-tab-group  mat-align-tabs="center" animationDuration="0ms" [(selectedIndex)]="tabIndex">
    <mat-tab [label]="'label.common.values' | translate">
        <ng-template matTabContent>
            <neq-rawmaterials-or-samples-values [(hasBeenTouched)]="valueHasBeenTouched"
                [productId]="id" (readOnlyChange)="isReadOnly=$event" (computeChange)="onComputeChange($event)"
            ></neq-rawmaterials-or-samples-values>
        </ng-template>
    </mat-tab>
    <mat-tab [label]="'label.common.results' | translate">
        <ng-template matTabContent>
            <neq-rawmaterials-or-samples-results [valueHasBeenTouched]="valueHasBeenTouched" (hasBeenSaved)="setValueHasBeenTouched(false)"
                [productId]="id" [matrices]="matrices" [calculationId]="calculationId" [isReadOnly]="isReadOnly"></neq-rawmaterials-or-samples-results>
        </ng-template>
    </mat-tab>
</mat-tab-group>
